import styled, { css } from 'styled-components';
import LANG from '../../lang/lang.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var LIST_INDENTATION = '23px';
var FooterWrapper = /*#__PURE__*/styled.footer.withConfig({
  displayName: "styledComponents__FooterWrapper",
  componentId: "sc-1mnzuyu-0"
})(["z-index:3;position:relative;bottom:0px;left:0px;right:0px;width:100%;background-color:", ";color:", ";font-family:", ";font-weight:300;font-size:", ";line-height:", ";& > div{display:flex;flex-wrap:wrap;padding:30px 30px 30px 30px;margin:0px;}@media (min-width:", "px) and (max-width:", "px){min-width:688px;overflow:hidden;}@media (max-width:", "px){font-size:", ";line-height:", ";}@media (max-width:", "px){max-width:", "px;}@media (max-width:", "px){max-width:", "px;}@media (max-width:", "px){max-width:", "px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, typography.fontFamily, rem(13), rem(20), BREAKPOINTS.MAX_768, BREAKPOINTS.MAX_1024, BREAKPOINTS.MAX_768, rem(13), rem(26), BREAKPOINTS.PHONE_PORTRAIT_LG, BREAKPOINTS.PHONE_PORTRAIT_LG, BREAKPOINTS.PHONE_PORTRAIT_MED, BREAKPOINTS.PHONE_PORTRAIT_MED, BREAKPOINTS.PHONE_PORTRAIT_SM, BREAKPOINTS.PHONE_PORTRAIT_SM);
process.env.NODE_ENV !== "production" ? FooterWrapper.displayName = 'FooterWrapper' : void 0;
var FooterMiddle = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__FooterMiddle",
  componentId: "sc-1mnzuyu-1"
})(["min-height:20px;margin:0 0 16px 0;padding:0px;font-size:", ";width:100%;color:", ";display:flex;flex-flow:row nowrap;justify-content:space-between;@media (max-width:", "px){flex-flow:column nowrap;}"], typography.fontSizeSmall, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, BREAKPOINTS.MAX_1024);
process.env.NODE_ENV !== "production" ? FooterMiddle.displayName = 'FooterMiddle' : void 0;
var SiteLinkList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__SiteLinkList",
  componentId: "sc-1mnzuyu-2"
})(["display:flex;justify-content:flex-start;margin:0;padding:0;list-style:none;flex-flow:row nowrap;@media (max-width:", "px){flex-flow:row wrap;}", ""], BREAKPOINTS.MAX_768, function (_ref4) {
  var lang = _ref4.lang;
  return lang === LANG.FR_CA && "\n      @media (max-width: ".concat(BREAKPOINTS.TABLET_PORTRAIT, "px) {\n        flex-flow: row wrap;\n\n      }");
});
process.env.NODE_ENV !== "production" ? SiteLinkList.displayName = 'SiteLinkList' : void 0;

var FooterLink = function FooterLink(_ref5) {
  var theme = _ref5.theme;
  return css(["a{color:", ";text-decoration:none;:hover,:focus{color:", ";border-bottom:", ";svg{path{fill:", ";}}}svg{path{fill:", ";}}}"], theme.colorPalette.neutralColors.light.shade_dark_3, theme.colorPalette.neutralColors.light.shade_white, "1px solid ".concat(theme.colorPalette.neutralColors.light.shade_white), theme.colorPalette.neutralColors.light.shade_white, theme.colorPalette.neutralColors.light.shade_dark_3);
};

var SiteLink = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__SiteLink",
  componentId: "sc-1mnzuyu-3"
})(["margin-right:32px;line-height:", ";padding-bottom:12px;white-space:nowrap;@media (max-width:", "px){width:50%;margin:0;}", " &:last-of-type{margin-right:0px;}.material-icons{font-size:", ";margin-left:5px;}", ";"], rem(22), BREAKPOINTS.MAX_768, function (_ref6) {
  var lang = _ref6.lang;
  return lang === LANG.FR_CA && "\n      @media (max-width: ".concat(BREAKPOINTS.TABLET_PORTRAIT, "px) {\n        width: 50%;\n        margin: 0;\n      }\n      @media (max-width: ").concat(BREAKPOINTS.PHONE_PORTRAIT_MED, "px) {\n        width: 100%;\n      }");
}, rem(12), FooterLink);
process.env.NODE_ENV !== "production" ? SiteLink.displayName = 'SiteLink' : void 0;
var SocialMediaLinks = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__SocialMediaLinks",
  componentId: "sc-1mnzuyu-4"
})(["display:flex;flex-flow:row nowrap;justify-content:flex-start;margin:0;padding:0;list-style:none;@media (max-width:", "px){margin-top:8px;}li{list-style:none;margin-right:24px;padding:2px;:hover,:focus{svg{path{fill:", ";}}}}"], BREAKPOINTS.MAX_768, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
});
process.env.NODE_ENV !== "production" ? SocialMediaLinks.displayName = 'SocialMediaLinks' : void 0;
var FooterBottom = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__FooterBottom",
  componentId: "sc-1mnzuyu-5"
})(["width:100%;border-top:", ";padding-top:30px;font-size:", ";display:flex;align-items:flex-start;& > span{color:", ";margin-left:40px;}@media (max-width:", "px){flex-direction:column;margin:0px auto 10px auto;width:100%;& > span{display:block;margin-left:0;margin-top:20px;}}"], function (_ref8) {
  var theme = _ref8.theme;
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_dark_1);
}, rem(13), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, BREAKPOINTS.MAX_768);
process.env.NODE_ENV !== "production" ? FooterBottom.displayName = 'FooterBottom' : void 0;
var ScreenReaderOnly = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__ScreenReaderOnly",
  componentId: "sc-1mnzuyu-6"
})(["position:absolute;top:auto;left:-9999px;overflow:hidden;width:0;height:1px;padding:0;"]);
process.env.NODE_ENV !== "production" ? ScreenReaderOnly.displayName = 'ScreenReaderOnly' : void 0;
var CopyrightYear = /*#__PURE__*/styled.span.attrs(function (props) {
  return {
    'aria-label': props.ariaLabel
  };
}).withConfig({
  displayName: "styledComponents__CopyrightYear",
  componentId: "sc-1mnzuyu-7"
})(["white-space:nowrap;@media (max-width:", "px){display:block;}"], BREAKPOINTS.PHONE_PORTRAIT_LG);
process.env.NODE_ENV !== "production" ? CopyrightYear.displayName = 'CopyrightYear' : void 0;
var FooterTop = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__FooterTop",
  componentId: "sc-1mnzuyu-8"
})(["width:100%;margin-bottom:30px;padding-bottom:30px;border-bottom:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_dark_1);
});
process.env.NODE_ENV !== "production" ? FooterTop.displayName = 'FooterTop' : void 0;
var LinkSection = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LinkSection",
  componentId: "sc-1mnzuyu-9"
})(["font-size:", ";line-height:", ";"], typography.fontSizeSmall, typography.lineHeight);
process.env.NODE_ENV !== "production" ? LinkSection.displayName = 'LinkSection' : void 0;
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-1mnzuyu-10"
})(["width:", ";display:flex;align-items:flex-start;"], LIST_INDENTATION);
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : void 0;
var LinkSectionButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__LinkSectionButton",
  componentId: "sc-1mnzuyu-11"
})(["font-size:inherit;color:inherit;font-family:", ";font-weight:", ";background:transparent;text-transform:uppercase;padding:0;margin:0;border:none;display:flex;flex-flow:row nowrap;justify-content:space-between;"], typography.fontFamily, typography.fontWeightDemibold);
process.env.NODE_ENV !== "production" ? LinkSectionButton.displayName = 'LinkSectionButton' : void 0;
var LinkSectionHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LinkSectionHeader",
  componentId: "sc-1mnzuyu-12"
})(["font-family:", ";font-weight:", ";color:", ";text-transform:uppercase;"], typography.fontFamily, typography.fontWeightDemibold, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
});
process.env.NODE_ENV !== "production" ? LinkSectionHeader.displayName = 'LinkSectionHeader' : void 0;
var LinkList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__LinkList",
  componentId: "sc-1mnzuyu-13"
})(["margin:0;padding:0;display:flex;flex-wrap:nowrap;flex-direction:row;@media screen and (max-width:", "px){flex-direction:column;padding-left:", ";}li{list-style:none;padding-top:10px;padding-right:80px;", ";}"], BREAKPOINTS.MAX_768, LIST_INDENTATION, FooterLink);
process.env.NODE_ENV !== "production" ? LinkList.displayName = 'LinkList' : void 0;

export { CopyrightYear, FooterBottom, FooterMiddle, FooterTop, FooterWrapper, IconWrapper, LinkList, LinkSection, LinkSectionButton, LinkSectionHeader, ScreenReaderOnly, SiteLink, SiteLinkList, SocialMediaLinks };
